export default __webpack_public_path__ + "static/media/my-img.fdc982cf.png";